import React, { useState } from 'react';

import { RadioButton } from './RadioButton';

type RadioGroupProps = {
  options: { label: string; value: string; checked?: boolean }[];
  direction?: 'row' | 'column';
  onChange: (value: string) => void;
};

export const RadioGroup = ({
  options,
  direction = 'column',
  onChange
}: RadioGroupProps) => {
  const [selectedValue, setSelectedValue] = useState<string | null>(() => {
    const defaultCheckedOption =
      options.find((option) => option?.checked) || null;
    return defaultCheckedOption ? defaultCheckedOption.value : null;
  });

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
    onChange(event.target.value);
  };

  return (
    <div
      className={`${
        direction === 'row' ? 'tw-flex-row tw-gap-5' : 'tw-flex-col'
      } tw-flex tw-gap-[10px]`}
    >
      {options.map((option, index) => (
        <RadioButton
          key={index}
          label={option.label}
          value={option.value}
          checked={selectedValue === option.value}
          onChange={handleRadioChange}
        />
      ))}
    </div>
  );
};
